module.exports = __webpack_public_path__ + "img/shoplogo.bbfeb4b6.svg";